import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button } from 'antd';
import dayjs from 'dayjs';
import {FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { downloadFiles } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;

const ClickOccupationReport = (props) => {

	//Variable declaration
	const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const expandedTableColumns = [
		{
			title: 'Supplier',
			dataIndex: 'partnerName',
			key: 'partnerName',
			render: (_, record) => {
				return (
					<>
						{record.logoURL && record.logoURL !== "" ?
							<Image src={record.logoURL} preview={false} width={100} /> :
							<span>{record.partnerName}</span>
						}
					</>
				)

			}
		},
		{
			title: 'Clicks',
			dataIndex: 'totalClicks',
			key: 'totalClicks',
			align: 'center'
		},
		{
			title: 'Cost',
			dataIndex: 'cost',
			key: 'cost',
			align: 'center'
		},
		{
			title: 'Cost/Clicks',
			dataIndex: 'costApplies',
			key: 'costApplies',
			align: 'center'
		},
		// {
		// 	title: 'Quality',
		// 	dataIndex: 'qualityApps',
		// 	key: 'qualityApps',
		// 	align: 'center',
		// 	sorter: (a, b) => a.qualityApps - b.qualityApps,
		// 	render: (_, record) => {
		// 		return (
		// 			<>
		// 				<span>{record.qualityApps + " "}</span><span>({record.qualityPer}%)</span>
		// 			</>
		// 		)
		// 	}
		// },
		// {
		// 	title: 'Cost/Quality',
		// 	dataIndex: 'costQuality',
		// 	key: 'costQuality',
		// 	align: 'center',
		// 	sorter: (a, b) => a.costQuality - b.costQuality,
		// },
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align: 'center',
			sorter: (a, b) => a.interview - b.interview,
			render: (_, record) => {
				return (
					<>
						<span>{record.interview + " "}</span><span>({record.interviewPer}%)</span>
					</>
				)
			}
		},
		{
			title: 'Cost/Interview',
			dataIndex: 'costInterview',
			key: 'costInterview',
			align: 'center',
			sorter: (a, b) => a.costInterview - b.costInterview,
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align: 'center',
			sorter: (a, b) => a.hired - b.hired,
			render: (_, record) => {
				return (
					<Space size={3}>
						<span>{record.hired + " "}</span><span>({record.hiredPer}%)</span>
					</Space>
				)
			}
		},
		{
			title: 'Cost/Hire',
			dataIndex: 'costHired',
			key: 'costHired',
			align: 'center',
			sorter: (a, b) => a.costHired - b.costHired,
		}
	];
	const columns = [
		{
			title: 'Occupation',
			dataIndex: 'occupation',
			key: 'occupation',
			sorter:(a, b) => a.occupation - b.occupation,
			render:(_,record)=>{
                return(
					<>
						<span>{record.occupation}</span>
					</>
				)
				
			}	
		},
		{
			title: 'Clicks',
			dataIndex: 'totalClicks',
			key: 'totalClicks',
			align:'center',
			sorter:(a, b) => a.totalClicks - b.totalClicks,
		},
		{
			title: 'Cost',
			dataIndex: 'cost',
			key: 'cost',
			align:'center',
			sorter:(a, b) => a.cost - b.cost,
		},
		{
			title: 'Cost/Clicks',
			dataIndex: 'costApplies',
			key: 'costApplies',
			align:'center',
			sorter:(a, b) => a.costApplies - b.costApplies,
		},
		// {
		// 	title: 'Quality',
		// 	dataIndex: 'qualityApps',
		// 	key: 'qualityApps',
		// 	align:'center',
		// 	sorter:(a, b) => a.qualityApps - b.qualityApps,
		// 	render:(_,record)=>{
    //             return(
		// 			<Space size={3}>
		// 				<span>{record.qualityApps+" "}</span><span>({record.qualityPer}%)</span>
		// 			</Space>
		// 		)
				
		// 	}
		// },
		// {
		// 	title: 'Cost/Quality',
		// 	dataIndex: 'costQuality',
		// 	key: 'costQuality',
		// 	align:'center',
		// 	sorter:(a, b) => a.costQuality - b.costQuality,
		// },
		{
			title: 'Interviews',
			dataIndex: 'interview',
			key: 'interview',
			align:'center',
			sorter:(a, b) => a.interview - b.interview,
			render:(_,record)=>{
                return(
					<>
						<span>{record.interview+" " }</span><span>({record.interviewPer}%)</span>
					</>
				)
				
			}
		},
		{
			title: 'Cost/Interview',
			dataIndex: 'costInterview',
			key: 'costInterview',
			align:'center',
			sorter:(a, b) => a.costInterview - b.costInterview,
		},
		{
			title: 'Hires',
			dataIndex: 'hired',
			key: 'hired',
			align:'center',
			sorter:(a, b) => a.hired - b.hired,
			render:(_,record)=>{
                return(
					<Space size={3}>
						<span>{record.hired+" "}</span><span>({record.hiredPer}%)</span>
					</Space>
				)
				
			}
		},
		{
			title: 'Cost/Hire',
			dataIndex: 'costHired',
			key: 'costHired',
			align:'center',
			sorter:(a, b) => a.costHired - b.costHired,
		}
	];
	const [monthlyData,setMonthlyData]=useState([]);
	const [currentPage,setCurrentPage]= useState(1);
	const [pageSize,setPageSize]=useState(25);
	const [rangePickerValue,setRangePickerValue]= useState([]);
	const [loader,setLoader]=useState(false);
	const [monthReportTotal, setMonthReportTotal] = useState([]);
	const [occupations, setOccupations] = useState([]);
	const [form] = Form.useForm();

	//On load function call
	useEffect(()=>{
		if(props&&props.dateSelectedValue){
		form.setFieldsValue({
			rangePicker:[dayjs(props.dateSelectedValue[0]),dayjs(props.dateSelectedValue[1])],
		})
		}else{
			form.setFieldsValue({
				rangePicker:[dayjs(),dayjs()],
			})
		}
		setCurrentPage(1);
		setPageSize(25);
		setRangePickerValue(props&&props.dateSelectedValue?[dayjs(props.dateSelectedValue[0]).format(constants.MonthFormat),dayjs(props.dateSelectedValue[1]).format(constants.MonthFormat)]:[dayjs().format(constants.MonthFormat),dayjs().format(constants.MonthFormat)]);
		GetMonthlyReportData(1,25,props&&props.dateSelectedValue?props.dateSelectedValue[0]:dayjs().format(constants.MonthFormat),props&&props.dateSelectedValue?props.dateSelectedValue[1]:dayjs().format(constants.MonthFormat));
		getOccupationsList(props&&props.dateSelectedValue?props.dateSelectedValue[0]:dayjs().format(constants.MonthFormat),props&&props.dateSelectedValue?props.dateSelectedValue[1]:dayjs().format(constants.MonthFormat));
	},[props]);

	//Functions
	//Function gets occupation list from API
	const getOccupationsList = async (startDate,endDate)=>{
		//setLoader(true);
		const response = await APIUtils.apiCall('GET',WebLinks.GetClickOccupations+buyerId+"&fromDate="+startDate+"&toDate="+endDate);
		const defaultItem ={value: 'allOccupation',label: 'Show All'};
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			let occupationList=response.resultObj.data?.map((item,index)=>({key:index, value:item.id, label:item.occupation+" ("+item.occupationCount+")"}))
			setOccupations([{...defaultItem}, ...occupationList] || [{...defaultItem}]);
		}else{
			setOccupations([...defaultItem]);
			message.error(response.resultObj.message);
		}
	//	setLoader(false);
	};

	const occupationsToString = (e) =>{				
		let newList=e;
		let selectedOccList=e?.filter((item)=>item==="allOccupation");
		if(e?.length==0){
			form.setFieldsValue({occupations:['allOccupation']})
		}
		if(e?.length==1 && selectedOccList.length>0){
			newList=[];
		}	
		if(e?.length>1){
			if(selectedOccList?.length>0){newList=e?.filter((item)=>item!=="allOccupation");}
			form.setFieldsValue({occupations:newList})
		}
		return newList || [];
	}

	//Function runs when range picker value is changed
	const RangePickerChanged= (_,dateString) => {
		props.changeDate(dateString);
		setRangePickerValue(dateString);
		GetMonthlyReportData(currentPage,pageSize,dateString[0],dateString[1]);
	};

	const downloadFile = () => {
		setLoader(true)
		let selectedOccList=occupationsToString(form.getFieldValue("occupations"));
		let apiurl=WebLinks.DownloadClickOccupationReportExcel+buyerId+ `&fromDate=${dayjs(rangePickerValue[0]).format(constants.MonthFormat)}&toDate=${dayjs(rangePickerValue[1]).format(constants.MonthFormat)}`;
		if(selectedOccList?.length>0){
			selectedOccList=selectedOccList.filter((item)=>item!=="allOccupation");
			let occupationIDS=selectedOccList.join(",");
			apiurl=apiurl+`&occupationId=${occupationIDS}`
		}
		downloadFiles(apiurl,"ClickOccupationReport.xlsx");
		setTimeout(() => {
				setLoader(false)
		}, 3000);
	};

	//Function to Month report data
	const GetMonthlyReportData =async(currentPage,pazeSize,startDate,endDate,selectedOccList=[])=>{
		setLoader(true);
		selectedOccList=occupationsToString(form.getFieldValue("occupations"));
		let apiurl=WebLinks.GetClickOccupationReportList+buyerId;
		let occupationIDS="";
		if(selectedOccList?.length>0){
			selectedOccList=selectedOccList.filter((item)=>item!=="allOccupation");
			occupationIDS=selectedOccList.join(",");
		}
		const response = await APIUtils.apiCall('GET',apiurl+"&fromDate="+startDate+"&toDate="+endDate+"&occupationId="+occupationIDS+"&limit="+pazeSize+"&pageNo="+currentPage);//"&limit="+pazeSize+"&pageNo="+currentPage);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			let dataResponse,count;
			dataResponse=response.resultObj.data;
			count=response.resultObj.getCount;
			setMonthReportTotal(dataResponse?.pop() || []);
			setMonthlyData(dataResponse);
			setLoader(false);
		}else{
			setMonthlyData([]);
			setLoader(false);
			message.error(response?.resultObj?.message || constants.ERROR_MESSAGE);
		}
	}
	//Function on change of application table
	const onchangeApplicationTable = (pagination, filters, sorter) =>{
		if(pagination){
			if(pageSize!==pagination.pageSize){
				setCurrentPage(1);
			}else{
				setCurrentPage(pagination?.current);
			}
			setPageSize(pagination?.pageSize);
			GetMonthlyReportData(pagination?.current,pagination?.pageSize,rangePickerValue[0],rangePickerValue[1])
		}
	};

	//Funcion to render inner table
	const getInnerTable = (tableData) => {
		return (
			<Table
				bordered
				size="small"
				columns={expandedTableColumns}
				dataSource={tableData}
				pagination={false}
				// pagination={{
				// 	defaultPageSize: 100,
				// 	pageSizeOptions: ["100", "250", "500"],
				// }}
			/>
		)
	}
	
	//Function to display the month total in the table
	const monthReportSummary =()=>{
		return (
			<>
				<Table.Summary.Row className='bg-teal-50'>
				<Table.Summary.Cell index={0} className='text-center'>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={1} align='center'>
						<strong>Totals</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={2} className='text-center'>
						<strong>{monthReportTotal.totalClicks}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={3} className='text-center'>
						<strong>{monthReportTotal.cost}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={4} className='text-center'>
						<strong>{monthReportTotal.costApplies}</strong>
					</Table.Summary.Cell>
					{/* <Table.Summary.Cell index={5} className='text-center'>
						<strong><Space size={3}>{monthReportTotal.qualityApps+" "}<span>({monthReportTotal.qualityPer}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={6} className='text-center'>
						<strong>{monthReportTotal.costQuality}</strong>
					</Table.Summary.Cell> */}
					<Table.Summary.Cell index={7} className='text-center'>
						<strong><Space size={3}>{monthReportTotal.interview+" "}<span>({monthReportTotal.interviewPer}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={8} className='text-center'>
						<strong>{monthReportTotal.costInterview}</strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={9} className='text-center'>
						<strong><Space size={3}>{monthReportTotal.hired+" "}<span>({monthReportTotal.hiredPer}%)</span></Space></strong>
					</Table.Summary.Cell>
					<Table.Summary.Cell index={10} className='text-center'>
						<strong>{monthReportTotal.costHired}</strong>
					</Table.Summary.Cell>
				</Table.Summary.Row>
			</>
		)
	};

	return (
		<>
		<Spin spinning={loader}>
			<div>
				<Form form={form} className='!w-full flex flex-wrap gap-3 justify-between items-center mb-3'>
					<Space wrap>
						<Form.Item name="rangePicker" className='mb-0'>
						<RangePicker picker="month" placeholder={["From", "To"]} onChange={RangePickerChanged} format={constants.MonthFormat} />
						</Form.Item>
					</Space>
					<Space wrap>
						<label>Filter by Occupation</label>
							<Form.Item name="occupations" initialValue={["allOccupation"]} className='mb-0' >
								<Select
									className='!w-72'
									mode="multiple"
									allowClear
									maxTagCount='responsive'
									options={occupations}
									// value={selectedOccupations}
									onChange={(e)=>{
										GetMonthlyReportData(currentPage,pageSize,rangePickerValue[0],rangePickerValue[1],occupationsToString(e));
									}}
									optionFilterProp="label"
									filterSort={(optionA, optionB) =>
									  (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
									}
								/>
							</Form.Item>
							<Tooltip placement='right' title="Download as Excel">
								<Button
										className='bg-green-800 text-white hover:!text-white hover:!border-green-500'
										icon={<FileExcelOutlined />}
										onClick={()=>{downloadFile()}}
								>
									Download as Excel
								</Button>
							</Tooltip>
					</Space>
				</Form>
				<div className='overflow-x-auto'>
					<Table
						columns={columns}
						dataSource={monthlyData}
						scroll={{
							x: 1000,
						}}
						sortDirections={['descend','ascend','descend']}
						// onChange ={onchangeApplicationTable}
						expandable={{
							expandedRowRender: (record) => (<div>
								{getInnerTable(record.occupationSubList)}
							</div>)
						}}
						rowKey="occupationId"
						// pagination={{
						// 	total: totalMonthCount,
						// 	// showSizeChanger: true,
						// 	// pageSizeOptions: ["25", "50", "100"],
						// 	// defaultPageSize: 25,
						// 	// current: currentPage,
						// }}
						pagination={false}
						summary={() => monthReportSummary()}
					/>
				</div>
			</div>
		</Spin>
		</>
	);
};

export default ClickOccupationReport;